module.exports = __webpack_public_path__ + "505e18069ad0ecd2373b8c592cab1eb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dockpad_slim_down_logo@svg.svg
// module id = ./src/assets/dockpad_slim_down_logo@svg.svg
// module chunks = 0